import React, { Component } from 'react';
import { HashRouter, Route, Switch } from 'react-router-dom';
import Loadable from 'react-loadable';
import './App.scss';

const loading = () => <div className="animated fadeIn pt-3 text-center">Yükleniyor...</div>;

const Confirm = Loadable({
  loader:()=> import('./containers/Confirm'),loading
})
// Containers
const DefaultLayout = Loadable({
  loader: () => import('./containers/DefaultLayout'),
  loading
});

// Pages
const SelectProject = Loadable({
  loader: () => import('./pages/SelectProject'),
  loading
});

const Login = Loadable({
  loader: () => import('./pages/Login'),
  loading
});

const LoginEtiqa = Loadable({
  loader: () => import('./pages/Login/LoginEtiqa'),
  loading
});

const Register = Loadable({
  loader: () => import('./pages/Register'),
  loading
});

const ForgetPassword = Loadable({
  loader: () => import('./pages/ForgetPassword'),
  loading
});

const Page404 = Loadable({
  loader: () => import('./views/Pages/Page404'),
  loading
});

const Page500 = Loadable({
  loader: () => import('./views/Pages/Page500'),
  loading
});

class App extends Component {

  render() {
    return (
      <HashRouter>
          <Switch>
            <Route exact path="/login" name="Login Page" component={Login} />
            <Route exact path="/loginetiqa" name="Login Page" component={LoginEtiqa} />
            <Route exact path="/register" name="Register Page" component={Register} />
            <Route exact path="/forget-password" name="Forget Password Page" component={ForgetPassword} />
            <Route exact path="/404" name="Page 404" component={Page404} />
            <Route exact path="/500" name="Page 500" component={Page500} />
            <Route exact path="/selectProject" name="Projeler" component={SelectProject} />
            <Route exact path="/confirm/:id" name="Confirmation" component={Confirm}/>
            <Route path="/" name="Ana Sayfa" component={DefaultLayout} />
          </Switch>
      </HashRouter>
    );
  }
}

export default App;
